import PayPerViewPop from "components/PayPerViewPop";
import { decodeHtmlEntities } from "constant/htmlEntities";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PayperviewService from "services/payperview/PayperviewServie";
import PaymentModal from "./videoPlayer/PaymentModal";
import { useDispatch, useSelector } from "react-redux";
import {
  countdownToTargetDate,
  formatToLocalDateString,
} from "utils/timeFunctions";
import { BsPlayCircleFill } from "react-icons/bs";
import NotificationModal from "components/NotificationModal";
import { AiOutlineArrowLeft } from "react-icons/ai";
import PayperviewCountdown from "components/skeleton/PayperviewCountdown";
import PayperviewDetail from "components/skeleton/PayperviewDetail";
import TicketVerificationModal from "components/TicketVerificationModal";
import LoginModel from "./shared/LoginModal";
import LazyLoadImg from "components/LazyLoadImg";
import WatchTrailerbutton from "components/shared/WatchTrailerbutton";
import PpvResurvebtnskeleton from "components/skeleton/PpvResurvebtnskeleton";
import { RouteName } from "constant/routeNames";
import { CiShop } from "react-icons/ci";
import { Helmet } from "react-helmet-async";
import { Notification } from "constant/notifications";
import { FaPlay } from "react-icons/fa";
import PpvVideoModal from "components/PpvVideoModal";
import { removeAllPlayer } from "redux/AudioPlayerRedux";
import Recordings from "./shared/Recordings";

interface NotificationMessage {
  heading: string;
  text: string;
  btnText: string;
}

function PayperviewDetailsPage() {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const { slug } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [event, setEvent] = useState<any>();
  const [countdown, setCountdown] = useState<any>();
  const [purchasedEvent, setPurchasedEvent] = useState<any>([]);
  const [purchased, setPurchased] = useState<boolean>(false);
  const [hasPurchased, setHasPurchased] = useState<boolean>(false);
  const [hasPurchasedMovie, setHasPurchasedMovie] = useState<boolean>(false);
  const [hasTicketVerified, setHasTicketVerified] = useState<boolean>(false);
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showTicketVerificationModal, setShowTicketVerificationModal] =
    useState(false);
  const [ticketToken, setTicketToken] = useState<string>("");
  const [remainingDays, setRemainingDays] = useState();
  const [notificationModals, setNotificationModals] = useState<
    NotificationMessage[]
  >([]);

  const [isLoadingCountdown, setIsLoadingCountdown] = useState<any>(false);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [isBtnLoading, setIsBtnLoading] = useState<any>(false);
  const FE_URL = process.env.REACT_APP_FRONTEND_URL;

  useEffect(() => {
    if (slug) {
      getEventData();
    }
  }, [slug]);

  useEffect(() => {
    if (event) {
      hasEventPurchased(event?.id);
    }
  }, [event]);

  useEffect(() => {
    if (event) {
      hasEventPurchasedMovie(event?.id);
    }
  }, [event]);

  useEffect(() => {
    if (countdown === "ended") {
      getEventData();
    }
  }, [countdown]);

  const getEventData = async () => {
    setIsLoading(true);
    try {
      const res = await PayperviewService.getEventByEventSlug(slug);
      setEvent(res.data);

      setIsLoadingCountdown(true);
      const targetDateStr = res.data?.event_formatted_date;
      const interval = setInterval(() => {
        const newCountdown = countdownToTargetDate(targetDateStr);
        setIsLoading(false);
        setIsLoadingCountdown(false);
        setCountdown(newCountdown);
        if (typeof newCountdown !== "object") {
          clearInterval(interval);
        }
      }, 1000);
    } catch (error) {
      console.log(error);
      // Handle error if event fetch fails
    }
  };

  useEffect(() => {
    if (loggedInUser !== null) {
      PayperviewService.getPurchasedEvents(loggedInUser?.id)
        .then((res) => {
          const eventdata = res.data;
          setPurchasedEvent(res.data);

          if (eventdata.length > 0) {
            const isPurchased = eventdata.some(
              (purchasedEvent: any) => purchasedEvent.id === event?.id,
            );
            console.log("Event Purchased", isPurchased);
            setPurchased(isPurchased);
          }
        })
        .catch((e: any) => {
          console.log("getPurchasedEvents ", e);
        });
    }
  }, [loggedInUser, event?.id]);

  const handleReservedButton = () => {
    if (!loggedInUser) {
      setShowLoginModal(true);
      return;
    }
    setShowCheckoutModal(true);
  };

  const closeLoginModal = () => {
    setShowLoginModal(false);
  };

  const closeModal = () => {
    setShowCheckoutModal(false);
  };

  const closeTicketModal = () => {
    setShowTicketVerificationModal(false);
  };

  const showNotificationModal = (
    heading: string,
    text: string,
    btnText: string,
  ) => {
    setNotificationModals([
      ...notificationModals,
      {
        heading: heading,
        text: text,
        btnText: btnText,
      },
    ]);
  };

  const closeNotificationModal = (index: number) => {
    const updatedModals = [...notificationModals];
    updatedModals.splice(index, 1);
    setNotificationModals(updatedModals);
  };

  const hasEventPurchased = async (event_id: any) => {
    const response = await PayperviewService.hasPurchasedEvent(event_id);
    setHasPurchased(response?.hasPurchased);
    setTicketToken(response?.ticket_token);
    setHasTicketVerified(response?.has_ticket_verified);
  };

  const hasEventPurchasedMovie = async (event_id: any) => {
    const response = await PayperviewService.hasPurchasedMovie(event_id);
    setHasPurchasedMovie(response?.isRentalValid);
    setRemainingDays(response?.remaining_days);
  };

  const handlePlayButton = () => {
    if (!hasTicketVerified) {
      setShowTicketVerificationModal(true);
    } else {
      navigate("/ppv/watch/event/" + slug, {
        state: { prevPage: event?.slug },
      });
    }
  };

  const handleFreePlayButton = () => {
    navigate("/ppv/watch/event/" + slug, { state: { prevPage: event?.slug } });
  };
  const handleMoviePlayButton = () => {
    navigate("/ppv/watch/event/" + slug, { state: { prevPage: event?.slug } });
  };
  const handelCategoryButton = () => {
    navigate(
      RouteName.PayPerView.replace(
        "*",
        RouteName.PayperviewDiscoverByGenreId.replace(
          ":slug",
          event?.category_slug,
        ),
      ),
      { state: { prevPage: event?.slug } },
    );
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 100);
  }, []);

  const [showTrailerModel, setShowTrailerModel] = useState(false);
  const handleWatchTrailer = async () => {
    dispatch(removeAllPlayer());
    setShowTrailerModel(true);
  };

  const closeTrailerModel = () => {
    setShowTrailerModel(false);
  };

  // shared modern styles
  const infoCard =
    "w-[90%] px-5 py-6 mb-8 text-gray-300 rounded-2xl border border-white/10 bg-white/[0.06] backdrop-blur-md max-sm:w-[98%]";
  const watchNowBtn =
    "flex items-center justify-start gap-3 rounded-full bg-gradient-to-r from-[#e30030] to-[#c70025] px-3 py-2 text-white shadow-lg shadow-red-600/30 transition-all duration-300 hover:scale-[1.02] hover:shadow-xl max-sm:w-[60%]";
  const buyBtn =
    "flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#e30030] to-[#c70025] px-5 py-2.5 text-white shadow-lg shadow-red-600/30 transition-all duration-300 hover:scale-[1.02] hover:shadow-xl max-sm:w-full max-lg:w-[90%]";

  return (
    <>
      <Helmet>
        <title>
          {event
            ? event?.seo_title
              ? event?.seo_title
              : event?.title
                ? `${event?.title} - AYOZAT`
                : "AYOZAT Pay-Per-View"
            : "AYOZAT Pay-Per-View"}
        </title>
        <meta name="description" content={event?.meta_description} />
        <link rel="canonical" href={`${FE_URL}/ppv/details/${event?.slug}`} />
        <meta name="keywords" content={event?.focus_keyword} />
        <meta property="og:title" content={event?.seo_title} />
        <meta property="og:description" content={event?.meta_description} />
        <meta property="og:image" content={event?.bannerImage} />
        <meta
          property="og:url"
          content={`${FE_URL}/ppv/details/${event?.slug}`}
        />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={event?.seo_title} />
        <meta name="twitter:description" content={event?.meta_description} />
        <meta name="twitter:image" content={event?.bannerImage} />
        <meta name="twitter:site" content="AYOZAT Payperview" />
        <meta
          name="twitter:url"
          content={`${FE_URL}/ppv/details/${event?.slug}`}
        />
      </Helmet>
      <div className="white-text relative flex h-auto min-h-[900px] w-full overflow-hidden rounded-lg object-cover max-sm:h-auto max-sm:w-full">
        <div
          className="absolute inset-0 scale-105 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${event?.bannerImage})`,
            zIndex: -1,
          }}
        ></div>

        {/* Cinematic scrims */}
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black/95 via-black/70 to-black/20 max-sm:via-black/85 max-sm:to-black/50"></div>
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent"></div>

        <div className="payperviewhero-back scrollbar-hide relative z-10 w-[35%] rounded-lg pb-10 max-sm:w-full max-lg:w-[60%]">
          <div>
            <button
              className="mt-5 ml-5 flex h-10 w-10 items-center justify-center rounded-full bg-black/50 backdrop-blur-md transition-all duration-300 hover:scale-105 hover:bg-white hover:text-black max-sm:ml-[15px]"
              onClick={() => {
                navigate(RouteName.PayPerView.replace("/*", ""));
              }}
            >
              <AiOutlineArrowLeft />
            </button>
          </div>

          <div className="font-rubik mt-10 ml-5 cursor-default text-left max-sm:ml-3 max-sm:pr-3">
            {" "}
            {!isLoading && (
              <>
                <h1 className="text-[36px] font-extrabold leading-[1.05] tracking-tight text-white drop-shadow-2xl max-sm:text-[28px]">
                  {decodeHtmlEntities(event?.title)}
                </h1>
                <div>
                  <p className="my-3 flex w-[630px] items-center gap-2 text-[15px] text-[#7B9DB4] max-sm:my-2 max-sm:ml-1 max-sm:w-[80%]">
                    {event?.host_logo && (
                      <LazyLoadImg
                        imgSrc={event?.host_logo}
                        imgAlt={"host"}
                        imgHeight={"40px"}
                        imgWidth={"40px"}
                        wrapperProps={{
                          style: {
                            width: "40px",
                            height: "40px",
                            display: "inline-block",
                            flexShrink: 0,
                          },
                        }}
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100%",
                          objectFit: "cover",
                          flexShrink: 0,
                        }}
                      />
                    )}
                    by{" "}
                    {decodeHtmlEntities(event?.host_name)}
                  </p>
                </div>

                <div className="flex items-center gap-2">
                  <div onClick={handelCategoryButton}>
                    <h2 className="mt-2 cursor-pointer rounded-full border border-white/20 bg-white/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-white backdrop-blur-sm transition-all hover:border-[var(--red)] hover:bg-[var(--red)]">
                      {event?.category}
                    </h2>
                  </div>
                  {parseFloat(event?.price) === 0 && (
                    <h2 className="mt-2 rounded-full bg-sky-400 px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-white">
                      Free content
                    </h2>
                  )}
                </div>
                {event?.duration && (
                  <div>
                    <h2 className="my-3 w-[40%] text-[13px] font-semibold text-white">
                      Duration: {event?.duration}
                    </h2>
                  </div>
                )}
                <div>
                  <h2 className="my-4 w-[90%] text-[14px] font-normal leading-relaxed text-white/80">
                    {decodeHtmlEntities(event?.description)}
                  </h2>
                </div>
                <div>
                  {event?.rentable ? (
                    <>
                      <h2 className="my-4 w-[90%] rounded-lg bg-white/10 px-3 py-1.5 text-center text-[13px] font-bold text-white backdrop-blur-sm max-sm:w-[98%]">
                        Available for Rent: {event?.rent_duration}
                        {event?.rent_duration > 1 ? <> Days</> : <> Day</>}
                      </h2>
                    </>
                  ) : (
                    <>
                      <h2 className="my-4 flex w-[90%] items-center text-[13px] font-bold text-white">
                        {formatToLocalDateString(event?.event_formatted_date)}
                        {event?.streaming_status === "streaming" &&
                          countdown === "ended" && (
                            <span className="ml-2 rounded-full bg-sky-400 px-2 py-1 text-xs text-white">
                              Streaming
                            </span>
                          )}
                        {event?.streaming_status === "ended" && (
                          <span className="ml-2 rounded-full bg-red-500 px-2 py-1 text-xs text-white">
                            Ended
                          </span>
                        )}
                      </h2>
                    </>
                  )}
                </div>
                {event?.trailer_url && (
                  <div className="mb-4 flex">
                    <button
                      className={`button-red mb-3 flex w-auto items-center rounded-full px-5 py-3 text-center text-xs text-white transition-all duration-300 hover:scale-[1.03] hover:shadow-lg hover:shadow-[var(--red)]/30 max-sm:mx-auto max-sm:w-full max-sm:justify-center max-sm:py-3 max-sm:text-[15px]`}
                      onClick={handleWatchTrailer}
                    >
                      <FaPlay className="mr-2" /> Watch trailer
                    </button>
                  </div>
                )}
              </>
            )}
            {isLoading && <PayperviewDetail />}
            {event?.rentable ? (
              <>
                {loggedInUser && purchased && (
                  <>
                    {hasPurchasedMovie ? (
                      <div className={infoCard}>
                        <h3 className="mb-3 text-xl font-bold text-gray-100">
                          You Can Watch Now!
                        </h3>
                        <span className="text-base">
                          The event is now live! Click the play button below to
                          enjoy the live broadcast.
                        </span>
                        <div>
                          <div className="mt-4">
                            <div className="flex items-center gap-2">
                              {remainingDays !== undefined && (
                                <>
                                  {remainingDays !== 0 ? (
                                    <>
                                      <h4 className="mb-0 text-xl font-bold text-gray-100">
                                        Movie Rental Expires in {remainingDays}
                                        {remainingDays > 1 ? (
                                          <> Days</>
                                        ) : (
                                          <> Day</>
                                        )}
                                      </h4>
                                    </>
                                  ) : (
                                    <>
                                      <h4 className="mb-0 text-xl font-bold text-gray-100">
                                        Movie Rental Expires Today
                                      </h4>
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className={infoCard}>
                        <h3 className="mb-3 text-xl font-bold text-gray-100">
                          Movie Expired!
                        </h3>
                        <div>
                          <div className="mt-4">
                            <div className="flex items-center gap-2"></div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {loggedInUser && hasPurchased && (
                  <div>
                    {event?.streaming_status === "streaming" &&
                      countdown === "ended" && (
                        <div className={infoCard}>
                          <h3 className="mb-3 text-xl font-bold text-gray-100">
                            Streaming Now!
                          </h3>
                          <span className="text-base">
                            The event is live now! Click the play button below
                            to enjoy the live broadcast.
                          </span>
                          <div>
                            {ticketToken && (
                              <div className="mt-4">
                                <p className="text-sm">Your Ticket </p>
                                <div className="flex items-center gap-2">
                                  <h4 className="mb-0 text-xl font-bold text-gray-100">
                                    {ticketToken}
                                  </h4>
                                  {hasTicketVerified ? (
                                    <span className="rounded-full bg-sky-400 px-2 py-1 text-xs text-white">
                                      Verified
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    {event?.streaming_status === "not started" &&
                      countdown !== "ended" && (
                        <div className={infoCard}>
                          <h3 className="mb-3 text-xl font-bold text-gray-100">
                            Get Ready for the Event!
                          </h3>
                          <span className="text-base">
                            The event has not started streaming yet. Please Stay
                            tuned for exclusive coverage.
                          </span>
                        </div>
                      )}
                  </div>
                )}
                <div>
                  {event?.streaming_status === "streaming" &&
                    countdown === "ended" &&
                    parseFloat(event?.price) === 0 && (
                      <div className={infoCard}>
                        <h3 className="mb-3 text-xl font-bold text-gray-100">
                          Streaming Now!
                        </h3>
                        {loggedInUser ? (
                          <>
                            <span className="text-base">
                              The event is live now! Click the play button below
                              to enjoy the live broadcast.
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="text-base">
                              The event is live now! Kindly login to the system
                              and Click the play button below to enjoy the live
                              broadcast.
                            </span>
                          </>
                        )}
                      </div>
                    )}
                  {event?.streaming_status === "not started" &&
                    countdown !== "ended" &&
                    parseFloat(event?.price) === 0 && (
                      <div className={infoCard}>
                        <h3 className="mb-3 text-xl font-bold text-gray-100">
                          Get Ready for the Event!
                        </h3>
                        <span className="text-base">
                          The event has not started streaming yet. Please Stay
                          tuned for exclusive coverage.
                        </span>
                      </div>
                    )}
                </div>
                {event?.streaming_status === "ended" && (
                  <div>
                    <div className={infoCard}>
                      <h3 className="mb-3 text-xl font-bold text-gray-100">
                        Event Streaming Ended
                      </h3>
                      <span className="text-base max-sm:w-full">
                        The live streaming for this event has concluded. Stay
                        tuned for future events and updates. If you missed the
                        live broadcast, check back later for on-demand content.
                      </span>
                    </div>
                  </div>
                )}
              </>
            )}
            {!event?.rentable && (
              <>
                {!isLoadingCountdown && (
                  <div className="flex w-[90%] flex-col justify-between overflow-hidden max-sm:w-full max-lg:w-[90%]">
                    {!isLoadingCountdown &&
                      countdown &&
                      countdown !== "ended" &&
                      event?.streaming_status !== "ended" && (
                        <>
                          <div className="mb-5 rounded-2xl border border-white/15 bg-black/40 px-5 py-4 backdrop-blur-md">
                            <p className="mb-3 text-center text-base font-semibold">
                              Event Starts in{" "}
                            </p>
                            <hr className="mx-auto my-3 w-full opacity-[30%]" />
                            <div className="flex justify-between">
                              <div className="flex-col text-center">
                                <h2 className="text-[12px] text-gray-300">
                                  Days
                                </h2>{" "}
                                <h2 className="text-[40px] font-extrabold text-red-600">
                                  {countdown.days?.toString().padStart(2, "0")}
                                </h2>
                              </div>
                              <div className="flex-col text-center">
                                <h2 className="text-[12px] text-gray-300">
                                  Hours
                                </h2>{" "}
                                <h2 className="text-[40px] font-extrabold text-red-600">
                                  {countdown.hours?.toString().padStart(2, "0")}
                                </h2>
                              </div>
                              <div className="flex-col text-center">
                                <h2 className="text-[12px] text-gray-300">
                                  Minutes
                                </h2>{" "}
                                <h2 className="text-[40px] font-extrabold text-red-600">
                                  {countdown.minutes
                                    ?.toString()
                                    .padStart(2, "0")}
                                </h2>
                              </div>
                              <div className="flex-col text-center">
                                <h2 className="text-[12px] text-gray-300">
                                  Seconds
                                </h2>{" "}
                                <h2 className="text-[40px] font-extrabold text-red-600">
                                  {countdown.seconds
                                    ?.toString()
                                    .padStart(2, "0")}
                                </h2>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                )}
                {countdown && isLoadingCountdown && <PayperviewCountdown />}
              </>
            )}
            <div>
              {event?.rentable ? (
                <>
                  {loggedInUser &&
                    hasPurchasedMovie &&
                    event?.allowed_to_watch && (
                      <>
                        <button
                          className={watchNowBtn}
                          onClick={handleMoviePlayButton}
                        >
                          <BsPlayCircleFill size={48} />
                          <h2 className="mx-3 my-auto text-[18px] text-white">
                            Watch Now
                          </h2>
                        </button>
                      </>
                    )}
                </>
              ) : (
                <>
                  <div>
                    {loggedInUser &&
                      event?.streaming_status === "streaming" &&
                      hasPurchased &&
                      event?.allowed_to_watch && (
                        <button
                          className={watchNowBtn}
                          onClick={handlePlayButton}
                        >
                          <BsPlayCircleFill size={48} />
                          <h2 className="mx-3 my-auto text-[18px] text-white">
                            Watch Now
                          </h2>
                        </button>
                      )}
                  </div>
                  <div>
                    {loggedInUser &&
                      event?.allowed_to_watch &&
                      event?.streaming_status === "streaming" &&
                      parseFloat(event?.price) === 0 && (
                        <button
                          className={watchNowBtn}
                          onClick={handleFreePlayButton}
                        >
                          <BsPlayCircleFill size={48} />
                          <h2 className="mx-3 my-auto text-[18px] text-white">
                            Watch Now
                          </h2>
                        </button>
                      )}
                  </div>
                </>
              )}
              {event?.rentable ? (
                <>
                  {event?.allowed_to_watch ? (
                    <div className="mt-5">
                      {!purchased &&
                        !isLoading &&
                        parseFloat(event?.price) !== 0 && (
                          <button className={buyBtn} onClick={handleReservedButton}>
                            <CiShop size={25} />
                            <h2 className="mx-3 my-auto text-[15px] text-white">
                              Rent Movie{" "}
                            </h2>{" "}
                            <h2 className="text-[30px] font-extrabold text-white">
                              {"£"}
                              {event?.price}
                            </h2>
                          </button>
                        )}

                      {isLoading && <PpvResurvebtnskeleton />}
                    </div>
                  ) : (
                    <>
                      {!isLoading && (
                        <p className="w-[90%] rounded-lg border-2 border-solid border-white p-4 text-white max-sm:w-[98%]">
                          {Notification.geoLocationNotAllowedText}
                        </p>
                      )}
                      {isLoading && <PpvResurvebtnskeleton />}
                    </>
                  )}
                </>
              ) : (
                <>
                  {event?.allowed_to_watch ? (
                    <div className="mt-5">
                      {!isLoading &&
                        !purchased &&
                        event?.streaming_status !== "ended" &&
                        parseFloat(event?.price) !== 0 && (
                          <button className={buyBtn} onClick={handleReservedButton}>
                            <CiShop size={25} />
                            <h2 className="mx-3 my-auto text-[15px] text-white">
                              Reserve Now{" "}
                            </h2>{" "}
                            <h2 className="text-[30px] font-extrabold text-white">
                              {"£"}
                              {event?.price}
                            </h2>
                          </button>
                        )}
                      {isLoading && <PpvResurvebtnskeleton />}
                    </div>
                  ) : (
                    <>
                      {!isLoading && (
                        <p className="w-[90%] rounded-lg border-2 border-solid border-white p-4 text-white max-sm:w-[98%]">
                          {Notification.geoLocationNotAllowedText}
                        </p>
                      )}
                      {isLoading && <PpvResurvebtnskeleton />}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
          {event?.isReplay === 1 && event?.replay_videos?.length >= 1 && (
            <Recordings
              loggedInUser={loggedInUser}
              hasPurchased={hasPurchased}
              event={event}
              isReplay={event?.isReplay}
            />
          )}
        </div>

        {/* Render notification modals */}
        {notificationModals.map((modalMessage, index) => (
          <NotificationModal
            key={index}
            isOpen={true}
            onClose={() => closeNotificationModal(index)}
            message={modalMessage}
          />
        ))}

        <TicketVerificationModal
          isOpen={showTicketVerificationModal}
          onClose={closeTicketModal}
          ppv_event={event}
        />

        <PayPerViewPop isOpen={showCheckoutModal} onClose={closeModal}>
          <>
            <PaymentModal ppv_event={event} />
          </>
        </PayPerViewPop>

        {showLoginModal ? (
          <LoginModel
            clickLogin={closeLoginModal}
            setShowLoginModal={setShowLoginModal}
          />
        ) : (
          <></>
        )}
        {showTrailerModel ? (
          <PpvVideoModal
            isOpen={true}
            onClose={closeTrailerModel}
            video_URL={event?.trailer_url}
            title={event?.title}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default PayperviewDetailsPage;